/*
 * Statement CSV: the shared CSV rules (util_components/csv_export/to_csv.js) plus a writer for
 * rows that are already formatted string arrays (the sheet's own header order).
 */
import {
  BOM,
  cell_text,
  guard_formula,
  money_text,
  quote_cell
} from '../../../util_components/csv_export/to_csv';

export { BOM, cell_text, guard_formula, money_text, quote_cell };

// header: string[]; rows: string[][] already formatted. Returns the whole file text.
export const to_csv_text = (header, rows, { bom = true } = {}) => {
  const line = (cells) => cells.map((c) => quote_cell(guard_formula(String(c)))).join(',');
  const out = [line(header), ...rows.map(line)];
  return (bom ? BOM : '') + out.join('\r\n') + '\r\n';
};
